export default function LinkAngledIcon({ className }: { className?: string }) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M6.14876 8.49213L4.28754 10.3533C3.59243 11.0484 3.1927 11.9943 3.20001 12.9883C3.20731 13.9823 3.5983 14.9338 4.32639 15.6395C5.03196 16.3676 5.98374 16.7585 6.97759 16.7658C7.99411 16.7733 8.91753 16.3961 9.61268 15.701L11.4739 13.8398M13.8512 11.5079L15.7125 9.64668C16.4076 8.95157 16.8073 8.00577 16.8 7.01175C16.7927 6.01774 16.4017 5.06617 15.6736 4.36056C14.9682 3.65516 14.0166 3.26415 13.0226 3.25684C12.0286 3.24954 11.0826 3.62658 10.3875 4.32171L8.52627 6.18292M7.17759 12.7726L12.7612 7.18901"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
